import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgAttention24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Attention",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 20.527H2.75a.748.748 0 0 1-.644-1.133l9.25-15.58c.27-.454 1.02-.454 1.289 0l9.25 15.58a.748.748 0 0 1-.645 1.133m-17.183-1.5h15.865L12 5.667z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 16.856,
  r: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 14.868a.75.75 0 0 1-.75-.75V10.04a.75.75 0 0 1 1.5 0v4.079a.75.75 0 0 1-.75.749"
}));

export { SvgAttention24 as default };
//# sourceMappingURL=Attention24.js.map
